import React from 'react';
import { Snackbar, Alert } from '@mui/material';

// App toast notifications. Rendered in a portal ABOVE everything (including open
// dialogs), anchored top-centre, and auto-dismissing — errors linger longer than
// successes. Pass whichever of `error` / `success` you use; call
// onClose('error' | 'success') to clear that message. A "clickaway" does not
// dismiss (so a stray click elsewhere won't hide an error the user hasn't read).
export default function Toast({ error = '', success = '', onClose }) {
  const clear = (kind) => (e, reason) => { if (reason !== 'clickaway') onClose && onClose(kind); };
  return (
    <>
      <Snackbar open={!!error} autoHideDuration={6000} onClose={clear('error')}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
        <Alert severity="error" variant="filled" sx={{ boxShadow: 4 }}
          onClose={() => onClose && onClose('error')}>
          {error}
        </Alert>
      </Snackbar>
      <Snackbar open={!!success} autoHideDuration={3000} onClose={clear('success')}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
        <Alert severity="success" variant="filled" sx={{ boxShadow: 4 }}
          onClose={() => onClose && onClose('success')}>
          {success}
        </Alert>
      </Snackbar>
    </>
  );
}
